var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.9997C3 11.6019 3.15804 11.2203 3.43934 10.939C3.72064 10.6577 4.10218 10.4997 4.5 10.4997H16.38L12.44 6.55969C12.175 6.27534 12.0308 5.89925 12.0377 5.51065C12.0445 5.12205 12.2019 4.75128 12.4768 4.47645C12.7516 4.20162 13.1224 4.0442 13.511 4.03734C13.8996 4.03049 14.2757 4.17473 14.56 4.43969L21.06 10.9397C21.3409 11.2209 21.4987 11.6022 21.4987 11.9997C21.4987 12.3972 21.3409 12.7784 21.06 13.0597L14.56 19.5597C14.2757 19.8247 13.8996 19.9689 13.511 19.962C13.1224 19.9552 12.7516 19.7978 12.4768 19.5229C12.2019 19.2481 12.0445 18.8773 12.0377 18.4887C12.0308 18.1001 12.175 17.724 12.44 17.4397L16.38 13.4997H4.5C4.10218 13.4997 3.72064 13.3417 3.43934 13.0604C3.15804 12.779 3 12.3975 3 11.9997Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRArrow);
export default __webpack_public_path__ + "static/media/ic_r_arrow.a686e77c9ee63df5519a6b274e0dc763.svg";
export { ForwardRef as ReactComponent };